module.exports = __webpack_public_path__ + "media/icons/box-check-dc116404.svg";